<template>
  <v-container>
    <v-card>
      <v-toolbar flat color="grey lighten-2">
        <v-toolbar-title>Operations</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn-toggle v-model="statusFilter" @change="filterOperationList">
          <v-btn value="SUCCESS">
            SUCCESS
          </v-btn>
          <v-btn value="FAILED">
            FAILED
          </v-btn>
          <v-btn value="RUNNING">
            RUNNING
          </v-btn>
          <v-btn value="QUEUED">
            QUEUED
          </v-btn>
        </v-btn-toggle>
      </v-toolbar>
      <div
        v-if="$apollo.queries.listOperationsOnShowcase.loading"
        class="d-flex justify-center mb-6"
      >
        <v-progress-circular indeterminate color="grey"></v-progress-circular>
      </div>

      <div v-else-if="listOperationsOnShowcaseErrors">
        <v-alert dense outlined type="error">
          {{ listOperationsOnShowcaseErrors }}
        </v-alert>
      </div>
      <div v-else-if="listOperationsOnShowcase">
        <v-data-table
          :headers="headers"
          :items="listOperationsOnShowcase.operations || []"
          :sort-by="['startDate']"
          multi-sort
          :sort-desc="[true, true]"
          no-data-text="No operations found."
          footer-props.items-per-page-text="Elements per site"
        >
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr>
              <td>{{ item.name }}</td>
              <td>
                <v-icon small :color="mapStatusColor(item.status)">{{
                  mapStatusIcon(item.status)
                }}</v-icon
                >&nbsp;
                <span :class="mapStatusColor(item.status) + '--text'"
                  >{{ item.status }}
                </span>
              </td>
              <td>{{ item.userId }}</td>
              <td>{{ formatDate(item.startDate) }}</td>
              <td>{{ formatDate(item.endDate) }}</td>
              <td>
                <v-icon @click="showOperationDetails(item)"
                  >mdi-information-outline</v-icon
                >
              </td>
            </tr>
          </template>

          <template slot="pageText" slot-scope="item">
            {{ item.pageStart }} von {{ item.pageStop }}
          </template>
        </v-data-table>
      </div>
    </v-card>
    <OperationDetails
      v-if="showDetails"
      :showcase="showcase"
      :operation="selectedOperation"
      @close="closeDetails"
    ></OperationDetails>
  </v-container>
</template>

<script>
import { LIST_SHOWCASE_OPERATIONS } from '../../constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import OperationDetails from './OperationsDetails'
import moment from 'moment'
import { ON_UPDATE_OPERATION } from '@/domain/showcases/constants/query'
import OperationEventBus from '@/domain/showcases/events/operationEventBus'
export default {
  name: 'ShowcaseOperationsList',
  components: {
    OperationDetails
  },
  data: () => ({
    statusFilter: null,
    selectedOperation: null,
    showDetails: false,
    headers: [
      { text: 'Name', value: 'name', sortable: true, icon: 'mdi-alert' },
      { text: 'Status', value: 'status', sortable: true },
      { text: 'User', value: 'userId', sortable: true },
      { text: 'Start Date', value: 'startDate', sortable: true },
      { text: 'End Date', value: 'endDate', sortable: true },
      { text: 'Details', value: 'details', sortable: true }
    ],
    listOperationsOnShowcase: [],
    listOperationsOnShowcaseErrors: null
  }),
  props: ['showcase'],
  apollo: {
    $client: DOMAIN_NAME,
    listOperationsOnShowcase: {
      query: LIST_SHOWCASE_OPERATIONS,
      variables() {
        return {
          showcaseId: this.showcase.showcaseId,
          statusFilter: this.statusFilter
        }
      },
      skip() {
        return !this.showcase
      },
      error(error) {
        this.listOperationsOnShowcaseErrors = JSON.stringify(error.message)
      }
    },
    $subscribe: {
      updatedOperation: {
        query: ON_UPDATE_OPERATION,
        result: ({ data }) => {
          // let updatedOperation = subscriptionData.data.onUpdateOperation
          // let operationIndex = previousResult.listOperationsOnShowcase.operations.findIndex(
          //     operation => operation.operationId === updatedOperation.operationId
          // )
          // if (
          //     operationIndex === -1 &&
          //     (this.statusFilter === null ||
          //         this.statusFilter === updatedOperation.status)
          // ) {
          //     this.listShowcaseOperationSteps.push(updatedOperation)
          // } else {
          //     this.listShowcaseOperationSteps.splice(
          //         operationIndex,
          //         1,
          //         updatedOperation
          //     )
          // }
          // return previousResult
        },
        error: error => {}
      }
    }
  },
  async mounted() {
    OperationEventBus.$on('operationStarted', operation => {
      this.statusFilter = null
      this.filterOperationList()
    })
  },
  methods: {
    filterOperationList() {
      this.$apolloProvider.clients[DOMAIN_NAME].query({
        query: LIST_SHOWCASE_OPERATIONS,
        variables: {
          showcaseId: this.showcase.showcaseId,
          statusFilter: this.statusFilter
        },
        fetchPolicy: 'network-only'
      })
        .then(response => {
          this.listOperationsOnShowcase = response.data.listOperationsOnShowcase
        })
        .catch(err => (this.listOperationsOnShowcaseErrors = err))
    },
    showOperationDetails: function(item) {
      this.selectedOperation = item
      this.showDetails = true
    },
    closeDetails: function() {
      this.selectedOperation = null
      this.showDetails = false
    },
    mapStatusIcon: function(status) {
      const icons = {
        SUCCESS: 'mdi-check-circle-outline',
        FAILED: 'mdi-alert-outline',
        RUNNING: 'mdi-sync mdi-spin'
      }
      return icons[status]
    },
    mapStatusColor(status) {
      const colors = {
        SUCCESS: 'green',
        FAILED: 'red',
        RUNNING: 'blue'
      }
      return colors[status]
    },
    formatDate: function(date) {
      return moment
        .utc(date)
        .local()
        .format('DD.MM.YY, HH:mm:ss')
    }
  }
}
</script>

<style scoped></style>
